import {MessageArg} from './types';
import {isValidElement, cloneElement} from 'react';
import {getMessageCode} from 'epic-localization/src/client/message/Message';
export {getMessageCode};

export {selectMessages} from 'epic-localization/src/client/reducers/localization.reducer';
// export {getMessageJsx} from 'epic-localization/src/client/message/Message';

export const getMessageJsx = function getMessageJsx<
    Messages extends Record<string, string>,
    MessageCode extends string,
    MessageArgs extends MessageArg[]
>(messages: Messages, code: MessageCode, args?: MessageArgs) {
    const message: string = getMessageCode(messages, code);
    if (!args || !message) return message || code;

    // turn "foo {0} bar" into ['foo ', '0', ' bar']
    const messageParts = message.split(/{(\d*)}/);
    let hasElement = false;

    const mappedParts = messageParts.map((str, i) => {
        // every second item should be replaced with an arg
        if (i % 2 === 0) return str;

        let replacement = args[Number(str)];

        if (replacement === null || replacement === undefined) {
            return `{${str}}`;
        }

        if (isValidElement<HTMLElement | JSX.Element>(replacement)) {
            replacement = cloneElement(replacement, {key: str});
            hasElement = true;
        }

        return replacement;
    });

    return hasElement ? mappedParts : mappedParts.join(' ');
};

export function getMessage(messages, code, args?) {
    let message = getMessageCode(messages, code);
    if (args && message) {
        for (const i in args) {
            if (Object.prototype.hasOwnProperty.call(args, i)) {
                message = message.split(`{${i}}`).join(`${args[i]}`);
            }
        }
    }
    return message || code;
}
